module Meevo.Plugins.PointPromotionCampaign {
    "use strict";

    enum SelectedRedeemByEnum
    {
        RedeemByBusinessPreference = 1,
        RedeemByDate = 2,
        RedeemByDaysAfterAward = 3,
    }

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Meevo.Model.IPointPromotionCampaign> {
        public model: Meevo.Model.IPointPromotionCampaign;

        public membersOnly: boolean;
        public nonMembersOnly: boolean;

        public selectedRedeemBy: SelectedRedeemByEnum;
        public selectedRedeemByEnum = SelectedRedeemByEnum;
        public tomorrow: Date;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.setInitialValues();

            this.tomorrow = moment().add('days', 1).startOf('day').toDate();
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data: Meevo.Model.IPointPromotionCampaign) => {
                this.model = data;
                this.loadClientsIncluded();
                this.loadRedeemBy();
            });
        }

        loadClientsIncluded() {
            switch (this.model.clientsIncluded) {
                case Meevo.Model.ClientsIncludedEnum.All:
                    this.membersOnly = true;
                    this.nonMembersOnly = true;
                    break;

                case Meevo.Model.ClientsIncludedEnum.MembersOnly:
                    this.membersOnly = true;
                    this.nonMembersOnly = false;
                    break;

                case Meevo.Model.ClientsIncludedEnum.NonMembersOnly:
                    this.membersOnly = false;
                    this.nonMembersOnly = true;
                    break;
            }
        }

        saveClientsIncluded() {
            if (this.membersOnly && !this.nonMembersOnly) {
                this.model.clientsIncluded = Meevo.Model.ClientsIncludedEnum.MembersOnly;
            } else if (this.nonMembersOnly && !this.membersOnly) {
                this.model.clientsIncluded = Meevo.Model.ClientsIncludedEnum.NonMembersOnly;
            } else {
                this.model.clientsIncluded = Meevo.Model.ClientsIncludedEnum.All;
            }
        }

        clientsIncludedChanged(checkbox: string) {
            if (!this.membersOnly && !this.nonMembersOnly) {
                this.membersOnly = !(checkbox === 'membersOnly');
                this.nonMembersOnly = !(checkbox === 'nonMembersOnly');
            }
        }

        loadRedeemBy() {
            if (this.model.redeemByDate && !this.model.redeemByDaysAfterAward) {
                this.selectedRedeemBy = SelectedRedeemByEnum.RedeemByDate;
            } else if (this.model.redeemByDaysAfterAward && !this.model.redeemByDate) {
                this.selectedRedeemBy = SelectedRedeemByEnum.RedeemByDaysAfterAward;
            } else {
                this.selectedRedeemBy = SelectedRedeemByEnum.RedeemByBusinessPreference;
            }

            if (!this.model.redeemByDaysAfterAward) {
                this.model.redeemByDaysAfterAward = 30;
            }
        }

        saveRedeemBy() {
            switch (this.selectedRedeemBy) {
                case SelectedRedeemByEnum.RedeemByBusinessPreference:
                    this.model.redeemByDate = null;
                    this.model.redeemByDaysAfterAward = null;
                    break;
                case SelectedRedeemByEnum.RedeemByDate:
                    this.model.redeemByDaysAfterAward = null;
                    break;
                case SelectedRedeemByEnum.RedeemByDaysAfterAward:
                    this.model.redeemByDate = null;
                    break;
            }
        }

        setInitialValues(): void {
        }

        preSave(): void {
            this.saveClientsIncluded();
            this.saveRedeemBy();
        }

        sectionModelRetrieved(): void {
            if (!this.model) return;

            this.loadClientsIncluded();
            this.loadRedeemBy();
        }

        setValidMinDateFilter = (date: Date) => {
            let minDate = moment(date).startOf('day')

            if (this.model.id && minDate.isSame(moment(this.model.originalStartDate).startOf('day'))) {
                return true;
            }

            let today = moment(this.model.currentDate).startOf('day')
            let validToDate = this.model.endDate ? minDate < moment(this.model.endDate).startOf('day') : true;
            return (minDate >= today) && validToDate;
        }

        public onRedeemByDaysAfterAwardLabelClick(isDisabled: boolean) {
            if (isDisabled) return;
            this.selectedRedeemBy = SelectedRedeemByEnum.RedeemByDaysAfterAward;
        }
    }
}